import React from "react";
import { useSelector } from "react-redux";
import { Nullable } from "../../../../../../types/utils";
import { OrderCostingVersion } from "../../../../../api/endpoints/Order";
import Col from "../../../../../components/Common/Col";
import Row from "../../../../../components/Common/Row";
import OrderPolicy from "../../../../../policies/OrderPolicy";
import { selectUser } from "../../../../../store/selectors/UserSelectors";

interface Props {
  ecquoteVersion: string;
  version?: Nullable<OrderCostingVersion>;
}

const CostingVersion = (props: Props) => {
  const { ecquoteVersion, version } = props;
  const user = useSelector(selectUser);

  if (!OrderPolicy.canViewEcQuoteVersion(user)) {
    return null;
  }

  return (
    <Row className="costing-version">
      <Col sm={12}>
        <span>
          {
            version &&
            <span>
              Costing version: {version.title},&nbsp;
            </span>
          }

          Ecquote version: {ecquoteVersion}
        </span>

      </Col>
    </Row>
  )
}

export default CostingVersion;
